import { UserResponseV1 } from '@core/models/user';

export const mockUser1: UserResponseV1 = {
  externalId: crypto.randomUUID(),
  userProfileId: crypto.randomUUID(),
  userId: crypto.randomUUID(),
  email: 'toby@dunder-mifflin.com',
  preferredName: 'Toby',
  firstName: 'Toby',
  lastName: 'Flenderson',
  phone: '5551230001',
  imageUrl: 'https://miro.medium.com/v2/resize:fit:470/0*Lep4xNi5nuwbpyvr.jpg',
  dateOfBirth: '1975-02-22',
  createdOn: '',
  modifiedOn: '',
  archivedOn: '',
  isActive: true
};

export const mockUser2: UserResponseV1 = {
  externalId: crypto.randomUUID(),
  userProfileId: crypto.randomUUID(),
  userId: crypto.randomUUID(),
  email: 'kelly@dunder-mifflin.com',
  preferredName: 'Kelly',
  firstName: 'Kelly',
  lastName: 'Kapoor',
  phone: '5551230002',
  imageUrl: 'https://i.pinimg.com/736x/8e/e4/26/8ee426c9225e90dd38b46e0cbb65d16d.jpg',
  dateOfBirth: '1980-06-01',
  createdOn: '',
  modifiedOn: '',
  archivedOn: '',
  isActive: true
};

export const mockUser3: UserResponseV1 = {
  externalId: crypto.randomUUID(),
  userProfileId: crypto.randomUUID(),
  userId: crypto.randomUUID(),
  email: 'erin@dunder-mifflin.com',
  preferredName: 'Erin',
  firstName: 'Erin',
  lastName: 'Hannon',
  phone: '5551230003',
  imageUrl: 'https://upload.wikimedia.org/wikipedia/en/9/93/Erin_Hannon.jpg',
  dateOfBirth: '1990-05-09',
  createdOn: '',
  modifiedOn: '',
  archivedOn: '',
  isActive: true
};

export const mockUser4: UserResponseV1 = {
  externalId: crypto.randomUUID(),
  userProfileId: crypto.randomUUID(),
  userId: crypto.randomUUID(),
  email: 'kevin@dunder-mifflin.com',
  preferredName: 'Kevin',
  firstName: 'Kevin',
  lastName: 'Malone',
  phone: '5551230004',
  imageUrl: '',
  dateOfBirth: '1978-06-01',
  createdOn: '',
  modifiedOn: '',
  archivedOn: '',
  isActive: true
};
